import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ShopComingSoon from "@/pages/ShopComingSoon";

// Renders the real shop page when the admin has turned OFF "Coming Soon",
// otherwise shows the Coming Soon placeholder.
export default function ShopGate({ children }) {
  const [comingSoon, setComingSoon] = useState(null);
  useEffect(() => {
    api.get("/shop/config")
      .then((r) => setComingSoon(r.data.coming_soon !== false))
      .catch(() => setComingSoon(true));
  }, []);
  if (comingSoon === null) return <div style={{ minHeight: "100vh", background: "var(--bq-bg)" }} data-testid="shop-gate-loading" />;
  return comingSoon ? <ShopComingSoon /> : children;
}
